<div class="h-100 main-bc b-logo" style="overflow: hidden;">
    <div class="h-100">
        <div fxLayout="column" class="w-100 h-100" fxLayoutAlign="start start">
            <div class="w-100 pl-20 pr-20 header" fxLayout="row" fxLayoutAlign="start center">
                <ui-kit-svg class="header-logo" ngClass.mobile="ml-16" name="header-logo"></ui-kit-svg>
            </div>
            <div fxLayout="column" fxLayoutAlign="center center" class="w-100 h-100">
                <div class="shadow-content pl-56 pr-56 pt-48 pb-48 mw-456 text-center" fxLayout="column" fxLayoutAlign="start center">
                    <div class="h2-semi-bold">Межбанковская система переводов и платежей</div>
                    <div class="t1 mt-24">Быстрые и надежные переводы для вашего бизнеса</div>
                    <ui-kit-button type="primary"
                                   label="Узнать больше"
                                   class="mt-40"
                                   (clickListener)="openDocs()">
                    </ui-kit-button>
                </div>
            </div>
        </div>
    </div>
</div>
